import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { forwardRef } from 'react';

import type { MenuItemProps, SelectProps } from '@mui/material';
import type { FC } from 'react';

export interface SelectionProps extends SelectProps {
  options: Array<
    {
      id: string;
      title: string;
      value: string;
    } & MenuItemProps
  >;
}

export const FormSelection: FC<SelectionProps> = forwardRef(
  function FormSelection({ label, sx, name, options, ...props }, ref) {
    return (
      <FormControl sx={sx}>
        <InputLabel id={`${name}-label`}>{label}</InputLabel>
        <Select
          ref={ref}
          label={label}
          labelId={`${name}-label`}
          id={`${name}-select`}
          {...props}
        >
          {options.map(({ title, value, id, ...props }) => (
            <MenuItem key={id} value={value} {...props}>
              {title}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
);
